
export const globalFunctions = {

  ////////////////////////////////////
  //Returns True If Int Or Float
  ////////////////////////////////////

  isIntOrFloat(value) {
    if (/^-{0,1}\d*\.{0,1}\d+$/.test(value)) {
      return true
    }
    return false
  },


  ///////////////////////////////////////
  //Returns the Current Date
  ///////////////////////////////////////

  getCurrentDate() {
    var currentdate = new Date()

    return currentdate.getDate() + "/"
      + (currentdate.getMonth() + 1) + "/"
      + currentdate.getFullYear()
  },


  ///////////////////////////////////////////
  //Returns The Current Date For DatePicker
  ///////////////////////////////////////////

  getCurrentDateForPicker() {
    let date = new Date()

    let month = date.getMonth() + 1
    if (month < 10) {
      month = "0" + month
    }

    let day = date.getDate()
    if (day < 10) {
      day = "0" + day
    }

    return date.getFullYear() + "-" + month + "-" + day
  },


  //////////////////////////////////////////////
  //Returns The Current Time For TimePicker
  //////////////////////////////////////////////

  getCurrentTimeForPicker() {
    let date = new Date()

    return date.getHours() + ":" + date.getMinutes()
  },

  /////////////////////////////////////////
  //Returns Amount In Account
  /////////////////////////////////////////

  getAccountCurrentAmount: function (account, acc) {
    
    for (let i = 0; i < acc.length; i++) {
      if (acc[i].accountName === account) {
        return acc[i].accountAmount
      }
    }

  },


  /////////////////////////////////////////
  //Returns Amount In Budget
  /////////////////////////////////////////

  getBudgetCurrentAmount: function (budget, bud) {
   
    for (let i = 0; i < bud.length; i++) {
      if (bud[i].budgetName === budget) {
        return bud[i].budgetAmount
      }
    }

  },


}



// WEBPACK FOOTER //
// ./src/javascript/globalFunctions.js